const useStyles = (isSmallScreen: boolean): any => ({
  outerContainer: {
    m: 1
  },
  skeleton: {
    width: '100%',
    m: 1,
    height: 728
  },
  innerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    m: 2
  },
  iconButton: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    padding: 0,
    marginRight: 0
  },
  filterPopoverPaper: {
    maxHeight: 300,
    overflowY: 'auto'
  },
  selectAllContainer: {
    display: 'block',
    mb: 1
  },
  groupContainer: {
    display: 'block',
    mb: 1
  },
  popoverContent: {
    p: 2,
    maxWidth: 300
  },
  cardPadding: {
    padding: {
      top: 20,
      left: isSmallScreen ? 10 : 20,
      right: isSmallScreen ? 10 : 60
    }
  }
});

export default useStyles;
